// extracted by mini-css-extract-plugin
export default {"title":"_404_title_QabgL"};